import React from 'react';
import JavascriptStringsMethods from './JavascriptStringsMethods.jsx';
import JavascriptStringsSearch from './JavascriptStringsSearch.jsx';
import JavascriptStringsReference from './JavascriptStringsReference.jsx';

export default function JsStrings() {
  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold">JS Strings</h1>
      <ul className="mt-4 list-disc ml-6">
        <li><a href='/javascript/strings/methods' className='underline'>JS String Methods</a></li>
<li><a href='/javascript/strings/search' className='underline'>JS String Search</a></li>
<li><a href='/javascript/strings/reference' className='underline'>JS String Reference</a></li>
      </ul>
    </div>
  );
}
